import React from "react"
import { useStaticQuery, graphql, navigate, Link } from "gatsby"

import GravityFormForm from 'gatsby-plugin-gravity-forms-ignitro'

import '../css/footer.css';

import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Logo from '../components/logo';
import Social from '../components/socialmedia';
import FooterMenu from '../components/footer-menu';
import PreFooter from '../components/prefooter';
import FooterForm from '../components/footer-form';

const Footer = (noSignUp) => {
  const data = useStaticQuery(graphql`
    {
      footer1: wpMenu(locations: {eq: FOOTER1}) {
        count
        id
        databaseId
        name
        slug
        menuItems {
          nodes {
            id
            databaseId
            title
            url
            cssClasses
            description
            label
            linkRelationship
            target
            parentId
          }
        }
      }
      footer2: wpMenu(locations: {eq: FOOTER2}) {
        count
        id
        databaseId
        name
        slug
        menuItems {
          nodes {
            id
            databaseId
            title
            url
            cssClasses
            description
            label
            linkRelationship
            target
            parentId
          }
        }
      }
      wp {
        acfOptionsFooter {
          themeOptionsFooter {
            partnerLogos{
              logo{
                altText
                localFile {
                  publicURL
                }
              }
            }
            footerLogo {
              altText
              localFile {
                publicURL
              }
            }
            bbbLogo {
              altText
              localFile {
                publicURL
              }
            }
            lloydsLogo {
              altText
              localFile {
                publicURL
              }
            }
            footerCopy
            privacy {
              ... on WpPage {
                id
                title
                link
              }
            }
            terms {
              ... on WpPage {
                id
                title
                link
              }
            }
          }
        }
        acfOptionsContact {
          themeOptionsContact {
            phoneLink
            phoneText
            usHeadquarters {
              address
              address2
              city
              state
              zip
            }
            caHeadquarters {
              address
              address2
              city
              postalCode
              province
            }
          }
        }
      }
      wpGfForm(databaseId: { eq: 3 }) {
        ...GravityFormFields
      }
    }
  `)

  const { usHeadquarters, caHeadquarters, phoneText, phoneLink } = data.wp.acfOptionsContact.themeOptionsContact;
  const { privacy, terms, footerCopy, footerLogo, bbbLogo, lloydsLogo, partnerLogos } = data.wp.acfOptionsFooter.themeOptionsFooter;
  // console.log(noSignUp);

  return (
    <React.Fragment>
      {/* <div className="container footerForm">
        <div className="grid smallGrid align-center">
          <div className="col-md-6 maincopy">
            <p>Sign up for our latest articles and events.</p>
          </div>
          <div className="col-md-6 footerFormRight"> */}
            {/* <GravityFormForm
              id={3}
              formData={data.allGfForm}
              lambda={process.env.GATSBY_LAMBDA_ENDPOINT}
              successCallback={handleSuccess}
              errorCallback={handleError}
            /> */}
            {/* <GravityFormForm data={data.wpGfForm} />
          </div>
        </div>
      </div> */}
       {!noSignUp.noSignUp  && (
  <div className="signup">
    <FooterForm data={data.wpGfForm} />
  </div>
)}


       <div className="prefooter">
        <PreFooter logos={partnerLogos}></PreFooter>
        </div>     

      <div className="container FooterMain">
        <div className="grid smallGrid">
          <div className="col-sm-4">
            <Logo className="flex-img footerLogo" logo={footerLogo} />
            <p className="footerCopy footerCopyLeft">{footerCopy}</p>
            <Social className="socialFooter" />
          </div>
          <div className="col-sm-8">
            <div className="grid">
              <div className="col-sm-4">
                <FooterMenu title={(data.footer1 && data.footer1.name) && data.footer1.name} menu={(data.footer1 && data.footer1.menuItems) && data.footer1.menuItems} />
              </div>
              <div className="col-sm-4">
                <FooterMenu title={(data.footer1 && data.footer2.name) && data.footer2.name} menu={(data.footer2 && data.footer2.menuItems) && data.footer2.menuItems} />
              </div>
              <div className="col-sm-4">
                <p className="footerTitle">Contact</p>
                <p className="footerCopy">If you have any questions or need help, feel free to contact with our team.</p>
                <a className="footerPhone" href={'tel:'+phoneLink}><FontAwesomeIcon icon={faPhoneAlt} /> {phoneText}</a>
                <br />
                <img className="flag" src="https://admin.roanokegroup.com/wp-content/uploads/2023/09/RNK_WebUpdts_Canada_APPROVED-09.png" />
                <p className="footerLocation">US CORPORATE HEADQUARTERS</p>
                <p className="footerAddress">{usHeadquarters.address}</p>
                <p className="footerAddress">{usHeadquarters.address2}</p>
                <p className="footerAddress">{usHeadquarters.city}, {usHeadquarters.state} {usHeadquarters.zip}</p>
                <br />
                <img className="flag" src="https://admin.roanokegroup.com/wp-content/uploads/2023/09/RNK_WebUpdts_Canada_APPROVED-08.png" />
                <p className="footerLocation">CANADA CORPORATE HEADQUARTERS</p>
                <p className="footerAddress">{caHeadquarters.address}</p>
                <p className="footerAddress">{caHeadquarters.address2}</p>
                <p className="footerAddress">{caHeadquarters.city}, {caHeadquarters.province} {caHeadquarters.postalCode}</p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="container footerCopyRight">
        <div className="grid smallGrid">
          <div className="col-sm-8">
            <h2>Solutions that Go the Distance.</h2>
            <p>&copy; 2024 Roanoke Insurance Group Inc.</p>
            <ul>
              <li><Link to="/sitemap/sitemap-0.xml">Sitemap</Link></li>

              { privacy &&
                <li><a href={privacy.link}>{privacy.title}</a></li>
              }
              { terms &&
                <li><a href={terms.link}>{terms.title}</a></li>
              }
            </ul>
          </div>
          <div className="col-sm-4 footerCopyRightImages">
            <a href="https://www.bbb.org/us/il/schaumburg/profile/insurance-services-office/roanoke-insurance-group-inc-0654-88320207#bbbonlineclick">
              <img src={(bbbLogo && bbbLogo.localFile) && bbbLogo.localFile.publicURL} alt={(bbbLogo && bbbLogo.altText) ? bbbLogo.altText : ''} />
            </a>
            <img src={(lloydsLogo && lloydsLogo.localFile) && lloydsLogo.localFile.publicURL} alt={(lloydsLogo && lloydsLogo.altText) ? lloydsLogo.altText : ''} />
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Footer